import axiosInstance from '../../../../core/api/axios';
import { PracticeEnemDaySelectionRequiredError } from '../../utils/enemDay';
import {
  IPracticeEnem,
  IPracticeEnemFeedback,
  IPracticeEnemOverview,
  IPracticeEnemYear,
  PracticeEnemDay,
} from '../../model/Enem';

export const getPracticesEnem = async (): Promise<IPracticeEnemYear> => {
  try {
    const { data } = await axiosInstance.get(`/simulated/last/all`);

    return data;
  } catch (e: any) {
    throw new Error(e);
  }
};

/** Resumo por dia para a tela de escolha. Não traz questões. */
export const getPracticeEnemOverview = async (
  practiceExamSlug: string
): Promise<IPracticeEnemOverview> => {
  try {
    const { data } = await axiosInstance.get(
      `/simulated/last/${practiceExamSlug}/overview`
    );

    return data;
  } catch (e: any) {
    throw new Error(e);
  }
};

export const getPracticeEnemExam = async (
  practiceExamSlug: string,
  day: PracticeEnemDay = null
): Promise<IPracticeEnem> => {
  try {
    const { data } = await axiosInstance.post(
      `/simulated/last/verify/started`,
      { simulated: practiceExamSlug, day }
    );

    return data;
  } catch (e: any) {
    throw new Error(e);
  }
};

export const startPracticeEnemExam = async (
  practiceExamSlug: string,
  day: PracticeEnemDay = null,
  foreignLanguage = ''
): Promise<IPracticeEnem> => {
  try {
    const { data } = await axiosInstance.post(`/simulated/last/start`, {
      simulated: practiceExamSlug,
      day,
      foreignLanguage,
    });

    return data;
  } catch (e: any) {
    throw new Error(e);
  }
};

export const savePracticeEnemExamAnswer = async (
  practiceExamId: string,
  answerId: string,
  questionId: string,
  day: PracticeEnemDay = null
): Promise<IPracticeEnem> => {
  try {
    // Rota própria do formato fixo: conhece o dia e valida o prazo no servidor.
    const { data } = await axiosInstance.post(`/simulated/last/answer`, {
      simulated: practiceExamId,
      answer: answerId,
      question: questionId,
      day,
    });

    return data;
  } catch (e: any) {
    throw new Error(e);
  }
};

export const finishPracticeEnemExam = async (
  practiceExamId: string,
  day: PracticeEnemDay = null,
  finishedBy: 'usuario' | 'tempo-esgotado' = 'usuario'
): Promise<IPracticeEnem> => {
  try {
    const { data } = await axiosInstance.post(`/simulated/last/finish`, {
      simulated: practiceExamId,
      day,
      finishedBy,
    });

    return data;
  } catch (e: any) {
    throw new Error(e);
  }
};

export const getPracticeEnemFeedback = async (
  practiceExamSlug: string,
  day: PracticeEnemDay = null
): Promise<IPracticeEnemFeedback> => {
  try {
    const { data } = await axiosInstance.post(
      `/simulated/last/${practiceExamSlug}/feedback`,
      { day }
    );

    return data;
  } catch (e: any) {
    if (e?.response?.data?.requiresDaySelection) {
      throw new PracticeEnemDaySelectionRequiredError();
    }

    throw new Error(e);
  }
};
